import React from "react";
import { Spin, Typography } from "antd";
import useStoreData from "./hooks/useStoreData";
import useProductSearch from "./hooks/useProductSearch";
import usePurchase from "./hooks/usePurchase";
import SearchBar from "./components/SearchBar";
import CategoryTabs from "./components/CategoryTabs";
import PurchaseModal from "./components/PurchaseModal";

const { Title } = Typography;

export default function Store() {
  const { products, setProducts, users, points, setPoints, loading } = useStoreData();
  const { searchTerm, setSearchTerm, categories } = useProductSearch(products);
  const purchase = usePurchase({ points, setPoints, setProducts });

  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <Spin size="large" tip="Cargando productos..." />
      </div>
    );
  }

  return (
    <div style={{ padding: "clamp(8px, 4vw, 32px)", maxWidth: 1200, margin: "0 auto" }}>
      <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
        Tienda de Recompensas
      </Title>

      <SearchBar value={searchTerm} onChange={setSearchTerm} />

      <CategoryTabs
        products={products}
        categories={categories}
        searchTerm={searchTerm}
        onSelectProduct={purchase.openModal}
      />

      <PurchaseModal purchase={purchase} users={users} />
    </div>
  );
}
